import { useState } from "react";
import { PlayCircle } from "lucide-react";
import { mediaSrc } from "@/components/ProductMediaUploader";

export function ProductGallery({ product }) {
  const images = product.images?.length ? product.images : [product.image_url];
  const items = [...images.map((u) => ({ type: "image", url: u })), ...(product.video_url ? [{ type: "video", url: product.video_url }] : [])];
  const [active, setActive] = useState(0);
  const cur = items[active] || items[0];

  return (
    <div data-testid="product-gallery">
      <div className="rounded-3xl overflow-hidden border border-[#E2DDD5] bg-[#E8F0EA] aspect-square">
        {cur.type === "video" ? (
          <video src={mediaSrc(cur.url)} controls className="w-full h-full object-contain bg-black" data-testid="gallery-video" />
        ) : (
          <img src={mediaSrc(cur.url)} alt={product.name} className="w-full h-full object-cover" data-testid="gallery-main-image" />
        )}
      </div>
      {items.length > 1 && (
        <div className="flex gap-2 mt-3">
          {items.map((it, i) => (
            <button key={it.url} type="button" onClick={() => setActive(i)} data-testid={`gallery-thumb-${i}`}
              className={`w-16 h-16 rounded-xl overflow-hidden border-2 relative ${i === active ? "border-[#1E3A2B]" : "border-[#E2DDD5]"}`}>
              {it.type === "video" ? (
                <div className="w-full h-full bg-[#1E3A2B] flex items-center justify-center text-white"><PlayCircle className="w-6 h-6" /></div>
              ) : (
                <img src={mediaSrc(it.url)} alt="" className="w-full h-full object-cover" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
